// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RxT5","index":"styles_index__n5Lkk"};